import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({staticClass:"px-8",style:({ background: _vm.isDarkMode ? '' : 'white' }),attrs:{"outlined":"","color":"primary"}},'v-btn',Object.assign({}, _vm.$attrs),false),_vm.$listeners),[(_vm.selected)?_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-check")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }